import Emoji from './Emoji';
import CheckBoxItem from './CheckBoxItem';
import CheckBoxList from './CheckBoxList';
import Image from './Image';
import CodeBlock from './CodeBlock';
import MathInline from './MathInline';
import MathBlock from './MathBlock';
import ContainerMessage from './ContainerMessage';
import ContainerMermaid from './ContainerMermaid';
import ContainerPlantuml from './ContainerPlantuml';
import Table from './Table';
import TableCell from './TableCell';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import {
  objectCommands,
  objectInputRules,
  objectKeyMaps,
  objectParsers,
  objectSchemas,
  objectSerializers,
} from '../helper/prosemirrorObjects';
import {schema as markdownSchema} from 'prosemirror-markdown';
import TableOfContents from './TableOfContents';
import Grid from './Grid';
import GridColumn from './GridColumn';
import Card from './Card';
import CardContent from './CardContent';
import CardContentHeader from './CardContentHeader';
import CardContentMeta from './CardContentMeta';
import CardContentDescription from './CardContentDescription';
import CardContentExtra from './CardContentExtra';
import AccordionTitle from './AccordionTitle';
import Accordion from './Accordion';
import AccordionContent from './AccordionContent';

const nodes = [
    new Emoji(),
    new CheckBoxItem(),
    new CheckBoxList(),
    new Image(),
    new CodeBlock(),
    new MathInline(),
    new MathBlock(),
    new ContainerMessage(),
    new ContainerMermaid(),
    new ContainerPlantuml(),
    new Table(),
    new TableCell(),
    new TableHeader(),
    new TableRow(),
    new TableOfContents(),
    new Grid(),
    new GridColumn(),
    new Card(),
    new CardContent(),
    new CardContentHeader(),
    new CardContentMeta(),
    new CardContentDescription(),
    new CardContentExtra(),
    new Accordion(),
    new AccordionTitle(),
    new AccordionContent()
];

const nodeSchemaSpecs = markdownSchema.spec.nodes
    .append(objectSchemas(nodes))
    .update("heading", {
        ...markdownSchema.spec.nodes.get("heading"),
        content: "(text | emoji)*",
    })
    .update("ordered_list", {
        ...markdownSchema.spec.nodes.get("ordered_list"),
        attrs: {order: {default: 1}, tight: {default: true}},
        toDOM: node => {
            return ['ol', {
                start: node.attrs.order === 1 ? null : node.attrs.order,
                'data-tight': 'true'
            }, 0]
        }
    })
    .update("bullet_list", {
        ...markdownSchema.spec.nodes.get("bullet_list"),
        attrs: {tight: {default: true}},
        toDOM: () => {
            return ['ul', {
                'data-tight': true
            }, 0]
        }
    });

const nodeParsers = objectParsers(nodes);
const nodeSerializers = objectSerializers(nodes);
const nodeKeyMaps = schema => objectKeyMaps(nodes, schema);
const nodeInputRules = schema => objectInputRules(nodes, schema);
const nodeCommands = view => objectCommands(nodes, view);

export {nodes, nodeSchemaSpecs, nodeParsers, nodeSerializers, nodeKeyMaps, nodeInputRules, nodeCommands};